<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="b2c_quality_compare">
    <h3 class="title" v-html="headerText"></h3>
    <div class="quality_item">
      <span class="quality_item_text">{{ finenessName }}</span>
      <div class="quality_item_right_wrap">
        <span class="quality_item_except_num">共{{ machineQuality.exceptionCount }}项异常</span>
        <span
          v-for="(exception, index) in group2ExceptionNum"
          :key="index"
          class="quality_item_abnormal"
        >
          {{ exception.text }}{{ exception.num }}项
        </span>
      </div>
    </div>
    <div class="quality_line_wrap">
      <div v-if="markPointList" class="quality_line_process">
        <span></span>
        <span></span>
        <span></span>
        <div class="avg_quality marker" :style="{ left: markPointList[0].xValue + '%' }">
          <div class="marker_wrap">{{ markPointList[0].showText }}</div>
        </div>
        <div class="cur_quality marker" :style="{ left: markPointList[1].xValue + '%' }">
          <div class="marker_wrap">{{ markPointList[1].showText }}</div>
        </div>
      </div>
      <p class="right_text">全新品质</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      machineQuality: {
        type: Object,
        default: () => {
          return {}
        },
      },
      finenessName: {
        type: String,
        default: () => '',
      },
    },
    computed: {
      headerText() {
        if (!this.machineQuality || !this.machineQuality.headerText) {
          return ''
        }
        return this.machineQuality.headerText.replace(/\${(.+)}/g, (match, p1) => {
          return `<span class="highlight">${p1}</span>`
        })
      },
      group2ExceptionNum() {
        if (!this.machineQuality || !this.machineQuality.group2ExceptionNum) {
          return []
        }
        const group2ExceptionNumData = []
        const { group2ExceptionNum } = this.machineQuality
        for (const i in group2ExceptionNum) {
          if (group2ExceptionNum[i] > 0) {
            group2ExceptionNumData.push({
              text: i,
              num: group2ExceptionNum[i],
            })
          }
        }
        return group2ExceptionNumData
      },
      markPointList() {
        if (!this.machineQuality || !this.machineQuality.markPointList) {
          return [{}, {}]
        }
        return this.machineQuality.markPointList
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

  .b2c_quality_compare {
    padding-bottom: 36px;

    .quality_item {
      display: flex;
      color: #181818;
      font-size: 20px;
      margin-bottom: 8px;
      margin-top: 2px;

      &_text {
        color: #666666;
        margin-right: 12px;
        flex-shrink: 0;
      }

      &_right_wrap {
        flex-wrap: wrap;
        display: flex;
        position: relative;
        padding-left: 12px;
        flex: 1;

        &::after {
          @include hairline(#dfdfdf);
          border-left-width: 1px;
        }

        & > span {
          flex-shrink: 0;
        }
      }

      &_abnormal {
        margin-right: 10px;
        color: #999999;
      }

      &_except_num {
        margin-right: 12px;
      }
    }

    .quality_line_process {
      padding-top: 116px;
      width: 100%;
      display: flex;
      position: relative;
      justify-content: space-between;

      & > span {
        width: 33%;
        background: #ff3333;
        border-radius: 4px;
        height: 16px;

        &:first-of-type {
          opacity: 0.05;
        }
        &:nth-of-type(2) {
          opacity: 0.15;
        }
        &:nth-of-type(3) {
          background: #ffcccc;
        }
      }
    }

    .right_text {
      text-align: right;
      font-size: 20px;
      color: #ffb6b6;
      margin-top: 10px;
    }

    .marker {
      position: absolute;
      font-size: 20px;
      height: 36px;
      padding: 0 8px;
      color: #ffffff;
      background: #999999;
      border-radius: 6px;
      white-space: nowrap;
      transform: translateX(-50%);
    }

    .marker_wrap {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        content: '';
        position: absolute;
        width: 16px;
        left: 50%;
        top: 100%;
        height: 96px;
        transform: translateX(-50%);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }
    }

    .avg_quality {
      left: 88%;
      bottom: 74px;

      .marker_wrap {
        &::after {
          height: 74px;
          background-image: url('https://pic3.zhuanstatic.com/zhuanzh/8a0a5015-14d5-4d46-8ed5-0f5026410682.png');
        }
      }
    }

    .cur_quality {
      left: 90%;
      bottom: 28px;
      background: #ff3333;

      .marker_wrap {
        &::after {
          height: 28px;
          background-image: url('https://pic2.zhuanstatic.com/zhuanzh/1ac7021c-573c-4bc7-accb-cb48e5e601bf.png');
        }
      }
    }
  }
</style>
